module.exports = __webpack_public_path__ + "assets/language-squares/it@2x-a0d9f158a714542dbdf190a4e2fa7fc5.jpg";